<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 24 24"
  fill="none"
  focusable="false"
  aria-hidden="true"
>
  <path
    [attr.fill]="fillColor"
    d="M7.145 22.916a2.11 2.11 0 1 0 0-4.218 2.11 2.11 0 0 0 0 4.218ZM16.568 22.916a2.11 2.11 0 1 0 0-4.218 2.11 2.11 0 0 0 0 4.218Z"
  />
  <path
    [attr.fill]="fillColor"
    d="M23.624 5.864a2.082 2.082 0 0 0-1.736-.911H4.312v-.844C4.312 2.946 3.366 2 2.202 2H.704a.703.703 0 0 0 0 1.406h1.5c.387 0 .703.315.703.703v13.17c0 .814.463 1.52 1.14 1.872a3.518 3.518 0 0 1 3.099-1.859 3.52 3.52 0 0 1 3.215 2.096h2.993a3.52 3.52 0 0 1 3.215-2.096c1.315 0 2.463.727 3.066 1.8a2.1 2.1 0 0 0 .887-1.066c.562-1.484 2.787-8.764 3.338-10.216a2.082 2.082 0 0 0-.235-1.946Zm-6.658 6.834c0 1.163-.946 2.11-2.109 2.11a2.112 2.112 0 0 1-2.109-2.11 2.111 2.111 0 0 1 2.812-1.988V7.89l-4.5 1.112v5.212l-.001.007a2.111 2.111 0 0 1-2.108 2.064 2.112 2.112 0 0 1-2.11-2.109 2.112 2.112 0 0 1 2.812-1.988V8.452c0-.323.22-.605.534-.683l5.908-1.46a.703.703 0 0 1 .871.682v5.707Z"
  />
  <path
    [attr.fill]="fillColor"
    d="M14.857 11.995a.704.704 0 1 0 .002 1.408.704.704 0 0 0-.002-1.408ZM8.95 13.473a.704.704 0 0 0 0 1.406.703.703 0 0 0 .703-.687v-.032a.703.703 0 0 0-.702-.687Z"
  />
</svg>
